/* eslint-disable no-unused-vars */
import {apolloClient} from '@/setup/apollo-setup';
// import axios from "axios";
import axios from "@/setup/axios-setup";
import {getField, updateField} from 'vuex-map-fields';
import {FORGOT_PASSWORD, LOGIN, REGISTER, RESET_PASSWORD, SIGN_OUT} from '@/queries/modules/user';
import {serverResponseStatusSet, error} from '@/utils/notification';

import {setDebugStatus} from '@/utils/debugger';
import {loginEntityFromHostname} from '@/utils/login-entity';

const $debug = setDebugStatus();

export default {
  namespaced: true,
  state: {
    currentUser: localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null,
    token: localStorage.getItem('token') != null ? localStorage.getItem('token') : null,
    loginError: null,
    loginStatus: null,
    error: null,
    processing: false,
    forgotMailSuccess: null,
    resetPasswordSuccess: null,
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
    setCurrentUser(state, payload) {
      state.currentUser = payload;
      state.processing = false;
      state.loginError = null;
      state.error = null;
    },
    setToken(state, payload) {
      state.token = payload;
      state.processing = false;
      state.loginError = null;
      state.error = null;
    },
    setLogout(state) {
      state.currentUser = null;
      state.token = null;
      state.processing = false;
      state.loginError = null;
      state.error = null;
    },
    setProcessing(state, payload) {
      state.processing = payload;
      state.loginError = null;
      state.error = null;
    },
    setLoginError(state, payload) {
      state.loginError = payload;
      state.currentUser = null;
      state.processing = false;
    },
    setLoginStatus(state, payload) {
      state.loginStatus = payload;
      state.currentUser = null;
      state.processing = false;
    },
    setError(state, payload) {
      state.error = payload;
      state.currentUser = null;
      state.processing = false;
    },
    setForgotMailSuccess(state) {
      state.loginError = null;
      state.currentUser = null;
      state.token = null;
      state.processing = false;
      state.forgotMailSuccess = true;
    },
    setResetPasswordSuccess(state) {
      state.loginError = null;
      state.currentUser = null;
      state.token = null;
      state.processing = false;
      state.resetPasswordSuccess = true;
    },
    clearError(state) {
      state.loginError = null;
      state.error = null;
    }
  },
  actions: {
    async login(context, payload) {
      localStorage.removeItem("token");

      const {commit} = context;
      const vm = payload.vm;
      commit('clearError');
      commit('setProcessing', true);

      try {
        const response = await axios({
          method: "post",
          url: process.env.VUE_APP_AUTH_SERVER + "/signin",
          data: {
            ...payload.credential,
            entity: loginEntityFromHostname(window.location.hostname),
          },
          // withCredentials: true
        })

        if (response.status >= 200 && response.status < 400) {
          if(response.data.changePassword){
            //redirect to change password page
            payload.vm.$router.push({
              name: 'user-change-password',
              params: {
                username: payload.credential.username,
                changePasswordReason: response.data.changePasswordReason,
                oldPassword: payload.credential.password,
              }
            });
            return
          }

          localStorage.setItem('token', response.data.token);
          localStorage.setItem('rsc', JSON.stringify(response.data.rsc));
          commit('setLoginStatus', serverResponseStatusSet("Authentication Success", response.data));
          payload.vm.$router.push("/");
        }
      } catch (e) {
        if (e.response) {
          commit('setLoginStatus', serverResponseStatusSet("Authentication Error", e.response.data));
          // commit("setLoginError", e.response.data);
          // commit('setError', error(e.response.data.message));
          // notifyError(e.response.data, "Authentication Error");
        }


        // try {
        //   const response = await axios({
        //     method: "post",
        //     url: LOGIN_ENDPOINT,
        //     data: {
        //       ...payload.data
        //     },
        //     // withCredentials: true
        //   })
        //   if (response.status === 200) {
        //     localStorage.setItem('token', response.data.token);
        //     vm.$router.push("/");
        //   }
        // } catch (err) {
        //   localStorage.removeItem('user');
        //   localStorage.removeItem('token');
        //   commit('setLoginError', error(err.message, 'notification.login-error-title'))

        //   setTimeout(() => {
        //     commit('clearError');
        //   }, 3000);
        // }


        // apolloClient
        //   .mutate({
        //     mutation: LOGIN,
        //     variables: payload
        //   })
        //   .then(({data}) => {
        //     localStorage.setItem('user', JSON.stringify(data.signIn.user));
        //     localStorage.setItem('token', data.signIn.token);

        //     commit('setToken', data.signIn.token);
        //     commit('setCurrentUser', data.signIn.user);
        //   })
        //   .catch((err) => {
        //     localStorage.removeItem('user');
        //     localStorage.removeItem('token');

        //     commit('setLoginError', error(err.message, 'notification.login-error-title'));

        //     setTimeout(() => {
        //       commit('clearError');
        //     }, 3000);
        //   });
      }
    },
    forgotPassword({commit}, payload) {
      commit('clearError');
      commit('setProcessing', true);

      apolloClient
        .mutate({
          mutation: FORGOT_PASSWORD,
          variables: payload
        })
        .then(() => {
          commit('clearError');
          commit('setForgotMailSuccess');
        })
        .catch((err) => {
          commit('setError', error(err.message));

          setTimeout(() => {
            commit('clearError');
          }, 3000);
        });
    },
    resetPassword({commit}, payload) {
      commit('clearError');
      commit('setProcessing', true);

      apolloClient
        .mutate({
          mutation: RESET_PASSWORD,
          variables: payload
        })
        .then(() => {
          commit('clearError');
          commit('setResetPasswordSuccess');
        })
        .catch((err) => {
          commit('setError', error(err.message));

          setTimeout(() => {
            commit('clearError');
          }, 3000);
        });
    },
    signOut({commit}, vm) {
      // Unsubscribe user session on back-end.
      axios({
        url: process.env.VUE_APP_AUTH_SERVER + "/signout",
        data: {
          token: localStorage.getItem("token")
        }
      }).then(r => {

        // TODO: Commit successfully signout result to inform user.


      }).catch(e => {

        // TODO: Send error log for stats


      }).finally(() => {

        // Removed token
        localStorage.removeItem('token');

        // TODO: Save and Reset App State

        if (vm) {
          if (vm.$router && vm.$route.fullPath !== "/user/login") {
            vm.$router.push("/user/login");
          }
        } else if (window.location.pathname !== process.env.BASE_URL + 'user/login') {
          window.location = process.env.BASE_URL + 'user/login';
        }
      })

      // apolloClient
      //   .mutate({
      //     mutation: SIGN_OUT
      //   })
      //   .then(() => {
      //     // localStorage.removeItem('user');
      //     localStorage.removeItem('token');
      //     vm.$router.push("/");

      //     commit('setLogout');
      //   })
      //   .catch((err) => {
      //     commit('setError', error(err.message));

      //     setTimeout(() => {
      //       commit('clearError');
      //     }, 3000);
      //   });
    },
    register({commit}, payload) {
      commit('clearError');
      commit('setProcessing', true);

      apolloClient
        .mutate({
          mutation: REGISTER,
          variables: payload
        })
        .then(({data}) => {
          localStorage.setItem('user', JSON.stringify(data.register.user));
          localStorage.setItem('token', data.register.token);

          commit('setToken', data.register.token);
          commit('setCurrentUser', data.register.user);
        })
        .catch((err) => {
          localStorage.removeItem('user');
          localStorage.removeItem('token');

          commit('setError', error(err.message));

          setTimeout(() => {
            commit('clearError');
          }, 3000);
        });
    },
    async resetPasswordByAdmin({commit}, payload) {

      commit('clearError');
      commit('setProcessing', true);

      try {
        const response = await axios({
          method: "post",
          url: process.env.VUE_APP_AUTH_SERVER + "/reset-password-by-admin",
          data: payload,
        })

        commit('setProcessing', false);

        return {
          error: response.data.status.error,
          data: response.data.data,
          message: response.data.status.message
        };
      } catch (e) {
        commit('setProcessing', false);
        if (e.response) {
          commit('setError', error(e.response.status.message));
        }
      }
    }
  }
}
